// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__QF9k0","container":"Overlay_container__xlG3q","buttons":"Overlay_buttons__QX7cd"};